module.exports = __webpack_public_path__ + "static/smile-decal-68e61d7e054a3f993863f4d3af77d5e0.jpg";